module.exports = __webpack_public_path__ + "static/media/threaten-banner.084b2db2.png";